import { render } from "./PersonalDataForm.vue?vue&type=template&id=d1092fac&scoped=true"
import script from "./PersonalDataForm.vue?vue&type=script&lang=ts"
export * from "./PersonalDataForm.vue?vue&type=script&lang=ts"

import "./PersonalDataForm.vue?vue&type=style&index=0&id=d1092fac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d1092fac"

export default script